import React from 'react'

import { nutrimaticLabels } from '@/nutrimatic'
import { cn } from '@/lib/utils'
import DoubleCurrencyLogo from '../../../../components/DoubleLogo'
import type { OnChainPairData } from '../../../../features/market/useOnChainPairData'
import { useIndexedPoolForCurrencies } from '../../../../features/market/useIndexedPoolForCurrencies'
import type { Currency } from '../../../../sdk'
import type { CandleInterval } from '@nutrimatic/sdk'

import { NutrimaticIntervalSelector } from '../../../../features/market/NutrimaticIntervalSelector'
import { resolveMarketPairLegs } from '../../../../features/market/resolveMarketPairLegs'
import { SwapMarketChartSection } from '../../../swap/SwapMarketChartSection'
import { SwapNutrimaticReadoutSpotQuoteFooter } from '../../../swap/nutrimatic/SwapNutrimaticReadoutSpotQuote'

/** Panel izquierdo de mercado reutilizable en tableta Nutrimatic (add / remove / import). */
export function LiquidityNutrimaticTabletMarketPane({
  currencyA,
  currencyB,
  pairData,
  rateHero,
  chartTimeframe,
  onChartTimeframeChange,
}: {
  currencyA: Currency | null | undefined
  currencyB: Currency | null | undefined
  pairData: OnChainPairData
  rateHero: React.ReactNode
  chartTimeframe: CandleInterval
  onChartTimeframeChange: (interval: CandleInterval) => void
}) {
  const indexedPool = useIndexedPoolForCurrencies(currencyA, currencyB)
  const { base, quote, pairLabel } = resolveMarketPairLegs(currencyA, currencyB, indexedPool)

  return (
    <div className="nm-tablet-chart-pane">
      <header className="nm-tablet-chart-pane__header">
        <div className="nm-tablet-chart-pane__pair">
          {base && quote ? (
            <DoubleCurrencyLogo currency0={base} currency1={quote} size={28} />
          ) : null}
          <div className="min-w-0">
            <p className="nm-tablet-chart-pane__kicker">{nutrimaticLabels.marketQuote}</p>
            <p className="nm-tablet-chart-pane__pair-label">{pairLabel}</p>
          </div>
        </div>
        <NutrimaticIntervalSelector
          variant="console"
          value={chartTimeframe}
          onChange={onChartTimeframeChange}
        />
      </header>

      <div className="nm-tablet-chart-pane__hero">{rateHero}</div>

      <div className={cn('nm-tablet-chart-pane__canvas', !pairData.exists && 'nm-tablet-chart-pane__canvas--empty')}>
        <SwapMarketChartSection
          integrated
          fillHeight
          timeframe={chartTimeframe}
          input={currencyA}
          output={currencyB}
        />
      </div>

      <footer className="nm-tablet-chart-pane__footer">
        <SwapNutrimaticReadoutSpotQuoteFooter
          pairData={pairData}
          base={base}
          quote={quote}
        />
      </footer>
    </div>
  )
}
